import { getToken } from '@services/api';
import axios from 'axios';

export const useProductInventory = () => {
  const baseURL = process.env.REACT_APP_PRODUCT_INVENTORY_SERVICE_BASE_URL;

  const getService = async () => {
    const token = await getToken();
    return axios.create({
      baseURL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  return { getService };
};
